import { useState } from 'react';
import { navItemType } from '@cx-web/domain-types';
import { useNavData } from '@cx-web/ui-shell/nav-data-context';

import Accordion from '../Accordion';

import styles from './SportsList.module.css';

export const SportsList = () => {
  const { mobileBottomNav } = useNavData();
  const allLinks = mobileBottomNav.find(item => item.type === navItemType.ALL_SPORTS_EXPANDABLE)?.items?.allLinks ?? [];

  const [activeAccordion, setActiveAccordion] = useState('');

  return (
    <div aria-label="Sport Categories" className={styles.sportsList}>
      {allLinks.map((sport, index) => (
        <Accordion
          headerIcon={sport.icon}
          headerLink={sport.link || ''}
          headerName={sport.name}
          isActiveAccordion={activeAccordion === sport.name}
          key={index}
          setActiveAccordion={sportName => setActiveAccordion(sportName)}
          subLinks={sport.subLinks}
        />
      ))}
    </div>
  );
};
